// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yVi9HBYIDQ5f7xN_Hc4Q{align-items:center;gap:16px;display:flex}.IzfMs8FPLAc5CcB380Om{flex-direction:column;gap:4px;display:flex}.iZytGhj8zQcEdq7MPjXW{border:1px solid var(--interaction-neutral-normal);border-radius:6px;align-items:center;gap:15.5px;margin-left:auto;padding:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"counterWithInfo": `yVi9HBYIDQ5f7xN_Hc4Q`,
	"counterWithInfoName": `IzfMs8FPLAc5CcB380Om`,
	"counterWithInfoCounter": `iZytGhj8zQcEdq7MPjXW`
};
export default ___CSS_LOADER_EXPORT___;
